import type { CreateReference } from '@quromedical/fhir-common';
import { FormCard, type RowConfig } from 'design-system';
import type React from 'react';
import { strings } from 'strings';

const createRows = (patients: CreateReference[] = []): RowConfig[] => {
  const label = patients.length
    ? strings.TitlePatient
    : strings.NoPatientsAssigned;

  const rows: RowConfig[] = [
    {
      icon: 'people-outline',
      fields: [
        {
          type: 'list',
          label,
          display: patients.map(
            (group) => group.display || strings.DisplayNotFound,
          ),
        },
      ],
    },
  ];

  return rows;
};

interface PractionerPatientsCardProps {
  data?: CreateReference[];
}

export const PractitionerPatientsCard: React.FC<
  PractionerPatientsCardProps
> = ({ data = [] }) => {
  const groupRows = createRows(data);

  return <FormCard title={strings.MyPatients} showIcons rows={groupRows} />;
};
